<template>
<div style="width: 100%; height: 100%;">
  <div id="neGameClient" />
</div>
</template>

<script>
import titleMixin from '@/mixins/titleMixin';
import { netentConfig } from '../../../../config';

export default {
  name: 'NetentView',
  mixins: [titleMixin],
  title() {
    const routeQuery = this.$route.query;
    return routeQuery.gameName ? `${routeQuery.gameName}` : 'Netent';
  },
  props: { userDevice: { type: String, required: true } },
  data() {
    return {
      netentExtendRef: null,
      stopGame: false,
      isGameReady: true
    }
  },
  computed: {
    launchTypeCalc() {
      const tempDevice = this.$route.query.device;
      if(this.userDevice === 'd' || tempDevice === 'd') return 'iframe';
      return 'iframeredirect';
    }
  },
  created() {
    const appWrapper = document.querySelector('.app-wrapper');
    appWrapper.classList.add('overflow-hidden');
    document.body.classList.add('netent-open');
  },
  mounted() {
    const { gameId, sessionId, lang: language, closeurl: lobbyURL } = this.$route.query;
    const config = {
      gameId,
      sessionId,
      language,
      staticServerURL: netentConfig.staticServer,
      gameServerURL: netentConfig.gameServer,
      fullScreen: true,
      launchType: this.launchTypeCalc, // desktop iframe for mobile redirect
      walletMode: 'seamlesswallet',
      iframeSandbox: 'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin allow-forms allow-pointer-lock',
      enforceRatio: false,
      width: '100%',
      height: '100%',
      debugMode: false,
      allowHtmlEmbedFullScreen: true,
      targetElement: 'neGameClient',
      lobbyURL
    };
    console.log(config);
    const success = netEntExtend => {
      console.log('success');
      console.log(netEntExtend);
      console.log(this);

      netEntExtend.addEventListener('gameReady', function() {});
      netEntExtend.addEventListener('gameRoundStarted', this.gameStarted);
      netEntExtend.addEventListener('gameRoundEnded', this.gameStopped);
      netEntExtend.addEventListener('autoplayStarted', this.autoplayStarted);
      netEntExtend.addEventListener('autoplayStopped', this.autoplayStopped);

      window.netentExtendRef = netEntExtend;
    };
    const error = function(error) { console.log(error); };
    console.log(JSON.stringify(config, null, 3));

    console.log('launch');
    window.netent.launch(config, success, error);

    window.addEventListener('message', e => {
      if(e.data === 'quick-transfer') {
        console.log('recieved from parent');
        console.log(this);
        console.log(this.netentExtendRef);
        window.netentExtendRef.call(
          'reloadBalance',
          [],
          function() { console.log('Reload Success') },
          function() { console.log('Reload Fail') }
        );
      }
    }, false);

    window.addEventListener('resize', this.resizeGame);

    window.addEventListener('message', this.receiveMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeGame);
    window.removeEventListener('message', this.receiveMessage);
    window.netentExtendRef.removeEventListener('gameRoundStarted', this.roundInSession);
    window.netentExtendRef.removeEventListener('gameRoundEnded', this.gameStopped);
    window.netentExtendRef.removeEventListener('autoplayStarted', this.autoplayStarted);
    window.netentExtendRef.removeEventListener('autoplayStopped', this.autoplayStopped);
  },
  methods: {
    resizeGame() {
      window.netentExtendRef.resize('100%', '100%');
    },
    receiveMessage(event) {
      this.eventW2G(event);
    },
    eventW2G(e) {
      let data;
      try { data = JSON.parse(e.data) }
      catch (e) { return }

      if (data._type) {
        switch (data._type) {
          case 'ucip.pause.w2gPauseCommand':
            this.stopGame = data.pause;
            if(!data.pause) this.gameStarted();
            else if(this.isGameReady) this.gameStopped();
            break;
          case 'ucip.autoplay.w2gInterruptGameplayCommand':
            window.netentExtendRef.call('stopAutoplay', [], this.autoplayStopped);
            break;
          case 'ucip.basic.w2gInitializationResponse':
            break;
        }
      }
    },
    roundInSession() { this.isGameReady = false; },
    autoplayStarted () { this.generateWrapperMessage({ _type: 'ucip.autoplay.g2wAutoplayStartNotification' }); },
    autoplayStopped () { this.generateWrapperMessage({ _type: 'ucip.autoplay.g2wAutoplayEndNotification' }); },
    gameStopped() {
      if(this.stopGame) this.generateWrapperMessage({ _type: 'ucip.pause.g2wPauseNotification', pause: true });
      this.isGameReady = true;
    },
    gameStarted() {
      this.generateWrapperMessage({ _type: 'ucip.pause.g2wPauseNotification', pause: false });
      this.isGameReady = true;
    },
    generateWrapperMessage (message) {
      const triggerMessage = JSON.stringify(message);
      console.log('GameCommunicator sent the following message: ', message);
      window.parent.postMessage(triggerMessage, '*');
    }
  }
}
</script>

<style lang="scss">
.netent-open {
  overflow: hidden;
}

#neGameClient {
  width: 100%;
  height: 100%;
}

.overflow-hidden {
  overflow: hidden;
}
</style>